<template>

    <div class="profile-dashboard__info">

        <div class="profile-dashboard__info-content">
            <div class="profile-dashboard__info-title">
                Привет, {{user.name}}!
            </div>
            <div class="profile-dashboard__info-description">
                Большое спасибо, что помогаете животным!<br>
                За последний месяц
                <span>
                    {{(dashboard && dashboard['last_month_raised']) || 0}} BYN
                </span>
                было собрано для помощи вашим животным!
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "UserDashboardInfo",
    props: ['user', 'dashboard'],

}
</script>

<style scoped>

</style>
